export class CampusUnitMessage {
    campusUnitsMessageId: number;
    message: string;
    active: boolean;
    startDate: Date;
    endDate: Date;
    updatedBy: string;
    updateDate: Date;
}
